export const JUDICIAL_STATUS = {
  LATE: '[L0] Atrasadas',
  BILLING_STARTED: '[L1] Cobrança Iniciada',
  NEGATIVE_OR_NONEXISTENT: '[L2] Retorno Negativo / Nulo',
  WAITING_BALANCE: '[L3] Aguardo Fatura / Saldo Atual',
  AWAITING_PAYMENT: '[L4] Aguardo Pagamento',
  ENERGY_REPORT: '[L5] Relatório Energia',
  START_NOTIFICATION: '[L6] Iniciar Notificações',
  BROKEN_AGREEMENT: '[L7] Acordo Quebrado',
  JUDICIALIZE: '[J0] Judicializar',
  SEND_FRIENDLY_NOTIFY: '[G0] Notif. Amigável à Enviar',
  REGISTERED_FRIENDLY_NOTIFY: '[G1] Notif. Amigável Registrada',
  EXTRAJUDICIAL_TO_NOTIFICATION: '[E0] Notif. Extrajudicial à Enviar',
  EXTRAJUDICIAL_NOTIFIED: '[E1] Notif. Extrajudicial Registrada',
  SEND_SERASA: '[S0] Serasa à Enviar',
  REGISTERED_SERASA: '[S1] Serasa Registrado',
  SEND_PROTEST: '[P0] Protesto à Enviar',
  PROTEST: '[P1] Protesto Registrado',
  CAUSES_TO_SEND: '[M0] Ação Monit. à Enviar',
  REGISTERED_CAUSES: '[M1] Ação Monit. Registrado',
  LOSS_OR_HARM: '[R0] Perda ou Prejuizo',
  INFORMAL_AGREEMENT: '[D0] Acordo Informal',
  AGREEMENT: '[D1] Acordo Assinado',
  SEND_OUTSOURCED: '[T1] Enviar cobrança terceirizada'
}

export const BILLING_STATUS = {
  PAID: '[OK] Pago',
  WAITING_PAYMENT: '[AB] Aberto',
}

export const INVOICE_STATUS = {
  ...BILLING_STATUS,
  ...JUDICIAL_STATUS,
  WAITING_GEN_INVOICE: '[F0] Sem Fatura',
}
